export default "__VITE_ASSET__B93lNdFU__";